import React from "react";
import { useSelector } from "react-redux";
const Pagination = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
}) => {
  const { isPartsURL, isAccessoriesURL } = useSelector((state) => state.domain);
  return (
    <div className="pagination-container">
      <div className="pagination-info">
        Page {currentPage} of {totalPages}
      </div>
      <div className="pagination-controls">
        <button
          className={`${
            isPartsURL
              ? "pagination-btn-parts"
              : isAccessoriesURL
              ? "pagination-btn-acc"
              : "pagination-btn"
          } ${currentPage === 1 ? 'disabled' : ''}`}
          onClick={onPrevious}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <button
          className={`${
            isPartsURL
              ? "pagination-btn-next-parts"
              : isAccessoriesURL
              ? "pagination-btn-next-acc"
              : "pagination-btn-next"
          } ${currentPage === totalPages ? 'disabled' : ''}`}
          onClick={onNext}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
